import { Modal } from 'antd';
import React, { useContext } from 'react';
import { LanguageContext } from '../../../shared/contexts/Language.context';
import Loader from '../../../shared/loaders/Loader';
import CustomButton from '../../CustomButton/CustomButton';
import CivitfunOnboarding from './CivitfunOnboarding';
import useDocumentCaptureHook from './DocumentCapture.hook';
import { ThemeContext } from '../../../shared/contexts/Theme.context';

export default function DocumentCapture({ currentValues, aliceSuccessAction }) {
  const {
    state: { literals, selectedLanguage },
  } = useContext(LanguageContext);
  const {
    state: { ocrVersion },
  } = useContext(ThemeContext);

  const { state, actions } = useDocumentCaptureHook();

  const isMobileViewport =
    typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
  const isDesktopViewport =
    typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches;
  const width = isMobileViewport ? '100vw' : isDesktopViewport ? '80vw' : '100%';

  return (
    <div>
      <Modal
        title={isMobileViewport ? null : literals?.['guestForm.takePhoto']}
        open={state.visible}
        onOk={() => actions.setVisible(false)}
        onCancel={() => actions.onCancelModal()}
        width={width}
        footer={null}
        closable={false}
        destroyOnClose={true}
        maskClosable={false}
        centered={!isMobileViewport}
        style={
          isMobileViewport
            ? {
                top: 0,
                margin: 0,
                paddingBottom: 0,
                maxWidth: '100vw',
              }
            : undefined
        }
        styles={
          isMobileViewport
            ? {
                wrapper: {
                  overflow: 'hidden',
                  display: 'block',
                },
                content: {
                  height: '100dvh',
                  padding: 0,
                  borderRadius: 0,
                  display: 'flex',
                  flexDirection: 'column',
                },
                body: {
                  flex: 1,
                  padding: 0,
                  overflow: 'hidden',
                },
              }
            : undefined
        }
      >
        <div
          style={{
            justifyContent: isMobileViewport ? 'stretch' : 'center',
            alignItems: isMobileViewport ? 'stretch' : 'center',
            display: isMobileViewport ? 'flex' : 'grid',
            width: '100%',
            height: isMobileViewport ? '100%' : undefined,
          }}
        >
          {state.loadUserData && <Loader></Loader>}
          <CivitfunOnboarding
            visible={state.visible}
            setVisible={actions.setVisible}
            nationality={currentValues.nationality}
            documentType={currentValues.driving_license_state ?? currentValues.document_type}
            selectedLanguage={selectedLanguage}
            literals={literals}
            aliceSuccessAction={aliceSuccessAction}
            setLoadUserData={actions.setLoadUserData}
          />
        </div>
      </Modal>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginLeft: '-8%' }}>
        <CustomButton
          text={literals?.['guestForm.takePhoto']}
          type="text"
          onClick={() => actions.setVisible(true)}
          small
        />
      </div>
    </div>
  );
}
